export const makeFetchSuccessActionType = (actionType: string) => {
  return actionType + '_FETCH_SUCCESS';
};

export const makeFetchFailedActionType = (actionType: string) => {
  return actionType + '_FETCH_FAILED';
};
